import { type FC, memo, useMemo } from "react"
import { TagsSlider } from "@/components/Tags/TagsSlider"
import { FAVORITES_DEFAULT_TAG_NAME } from "@/hooks/favorites"
import { useAppSelector } from "@/hooks/redux"

type GroupsTagsPropsType = {
  selectedGroup: string | null
  onSelectGroup: (id: string | number) => void
  onDeleteGroup: (id: string | number) => void
}

const collator = new Intl.Collator("ru")

export const GroupsTags: FC<GroupsTagsPropsType> = memo(
  ({ selectedGroup, onSelectGroup, onDeleteGroup }) => {
    const { groups: rawGroups } = useAppSelector(({ favorites }) => favorites)

    const groups = useMemo(() => {
      const groupsSorted = [...(rawGroups || [])].sort((a, b) => {
        if (a.name === FAVORITES_DEFAULT_TAG_NAME) return -1
        if (b.name === FAVORITES_DEFAULT_TAG_NAME) return 1

        return collator.compare(a.name, b.name)
      })

      return groupsSorted.map(({ uid, name, quantity }) => ({
        id: uid,
        name,
        qty: quantity,
        removable: name !== FAVORITES_DEFAULT_TAG_NAME,
      }))
    }, [rawGroups])

    return (
      <TagsSlider
        tags={groups}
        selectedCategory={selectedGroup}
        onSelectTag={onSelectGroup}
        onClearTag={onDeleteGroup}
      />
    )
  },
)

GroupsTags.displayName = "GroupsTags"
